@let objectCard = objectCard$ | async;
@let cardSettings = objectCardSettingsFromCurrentUser$ | async;
@if (isFixed) {
  <!-- Фиксированная карточка раскрыта целиком, скроллится вместе со списком. Появление данных
       анимируется по высоте вместе с подложкой и её отступами, чтобы строки списка ниже
       не прыгали ни при клике, ни при приходе данных. Шапки с действиями у неё нет. -->
  <tui-expand class="fixed-expand" [expanded]="!!objectCard">
    <ng-template tuiItem>
      <div class="testWrapp testWrapp_fixed">
        <ng-container [ngTemplateOutlet]="cardContent" />
      </div>
    </ng-template>
  </tui-expand>
} @else {
  <div class="testWrapp">
    <div class="icons-top">
      @if (headerActionsTemplate && (objectInfo$ | async); as objectInfo) {
        <ng-container
          [ngTemplateOutlet]="headerActionsTemplate"
          [ngTemplateOutletContext]="getHeaderActionsContext(objectInfo)"
        />
      }
      <tui-icon class="close" (click)="closePopup()" [icon]="'common/assets/icons/cross.svg'" />
    </div>

    <tui-scrollbar class="popup-closure-marker">
      <ng-container [ngTemplateOutlet]="cardContent" />
    </tui-scrollbar>
  </div>
}

<ng-template #cardContent>
  <div class="object-card wrapper-col">
    @if (objectCard) {
      @for (blockKey of cardSettings?.blocks ?? []; track blockKey) {
        @if (blockKey === 'general' || objectCard.hasOwnProperty(blockKey)) {
          <div class="wrapper popup-closure-marker" [class.no-scroll]="blockKey === 'general'">
            @if (!expandableBlocks.includes(blockKey)) {
              <ng-container
                [ngTemplateOutlet]="getTemplate(blockKey)"
                [ngTemplateOutletContext]="
                  getTemplateContext(objectCard, blockKey, cardSettings!.generalContent)
                "
              />
            } @else {
              <div
                class="wrapper-row expand-title"
                (click)="expandedItemsState[blockKey] = !expandedItemsState[blockKey]"
              >
                <p>{{ blockKey | join: ['objectCard'] | translate }}</p>
                <tui-icon
                  class="icon accordion-btn"
                  [style.transform]="expandedItemsState[blockKey] ? 'rotate(180deg)' : 'none'"
                  [icon]="'common/assets/icons/chevronDown.svg'"
                />
              </div>
              <tui-expand class="popup-closure-marker" [expanded]="!!expandedItemsState[blockKey]">
                <ng-container
                  [ngTemplateOutlet]="getTemplate(blockKey)"
                  [ngTemplateOutletContext]="
                    getTemplateContext(objectCard, blockKey, cardSettings!.generalContent)
                  "
                />
              </tui-expand>
            }
          </div>
        }
      }
    } @else if (!isFixed) {
      <div style="height: 100px" class="popup-closure-marker">
        <app-content-loader [textEvent]="'Loading object info'" [isVisibleButton]="false" />
      </div>
    }
  </div>
</ng-template>

<!--
  Поля блока general включаются по отдельности (current_user.objectCardSettings.general.content).
  Имя объекта видно всегда, разделители рисуются только перед видимыми строками.
-->
<ng-template #general let-data="data" let-fields="fields">
  @let general = getGeneralType(data);
  <div class="object-card__general wrapper-col">
    <div class="general-header">
      @if (fields.icon) {
        <div
          class="general-header__icon"
          [style.color]="general.objectIconColor"
          [innerHTML]="general.iconId | objectIcon"
        ></div>
      }
      <span class="general-header__name" tuiHintOverflow>{{ general.name }}</span>
      @if (fields.satellites) {
        <span
          class="general-header__metric"
          [tuiHint]="getEnding(general.lastMessage?.pos?.sc || 0, 'satellite') | translate"
        >
          <tui-icon [icon]="'common/assets/icons/satellites.svg'" />
          {{ general.lastMessage?.pos?.sc ?? '-' }}
        </span>
      }
      @if (fields.speed) {
        <span class="general-header__metric">
          <tui-icon class="speedometer" [icon]="'common/assets/icons/speedometer.svg'" />
          {{ general.lastMessage?.pos?.s ?? '-' }} {{ 'KM_H' | translate }}
        </span>
      }
    </div>
    @if (fields.address) {
      <hr />
      <div class="address wrapper-row">
        <span>
          {{ general.address || 'not_data.object_card.address' | translate }}
        </span>
        @if (general.address) {
          <tui-icon
            class="copy"
            (click)="onCopyAddress(general.address)"
            [tuiHint]="(general.address ? 'Copy address' : '-') | translate"
            [tuiHintHideDelay]="0"
            [icon]="'common/assets/icons/copy.svg'"
          />
        }
      </div>
    }
    @if (fields.t) {
      <hr />
      @if (general.lastMessage?.t) {
        <div>
          <span class="fw500">{{ 'LAST_MESSAGE' | translate }} </span>
          <span>~ {{ formatDateToRelative(general.lastMessage?.t) }}, </span>
          <span>{{ general.lastMessage?.t | customDate }} </span>
        </div>
      } @else {
        <span>{{ 'not_data.object_card.lastMessage' | translate }}</span>
      }
    }
    @if (fields.tpos) {
      <hr />
      @if (general.lastMessage?.tpos) {
        <div class="wrapper-row">
          <div>
            <span class="fw500">{{ 'Last coordinates' | translate }} </span>
            <span>~ {{ formatDateToRelative(general.lastMessage?.tpos) }}, </span>
            <span>{{ general.lastMessage?.tpos | customDate }} </span>
          </div>
          <tui-icon
            class="copy"
            (click)="onCopyCoordinates(general.lastMessage)"
            [tuiHint]="(general.lastMessage ? 'Copy coordinates' : '') | translate"
            [tuiHintHideDelay]="0"
            [icon]="'common/assets/icons/copy.svg'"
          />
        </div>
      } @else {
        <span>{{ 'not_data.object_card.lastCoordinates' | translate }}</span>
      }
    }
  </div>
</ng-template>

<ng-template #connectionSettings let-data="data">
  @let connectionSettings = getConnectionSettingsType(data);

  <hr />

  <div class="object-card__connection-settings wrapper-col">
    <ul class="square">
      <li>
        <span class="fw500">{{ 'deviceTypeId' | translate }}: </span>
        <span>{{ connectionSettings.deviceTypeName }}</span>
      </li>
      <li>
        <span class="fw500">{{ 'uniqueId' | translate }}: </span>
        <span>{{ connectionSettings.uniqueId }}</span>
      </li>
      <li>
        <span class="fw500">{{ 'phoneNumber' | translate }}: </span>
        <span>{{ connectionSettings.phoneNumber }}</span>
      </li>
    </ul>
  </div>
</ng-template>

<ng-template #drivers let-data="data">
  @let drivers = getDriversType(data);

  <hr />

  @if (drivers.length) {
    <div class="object-card__drivers">
      <ul class="disc">
        @for (driver of drivers; track driver.id) {
          <li>
            <span class="fw500">{{ driver.name }}: </span> <span>{{ driver.phoneNumber }}</span>
          </li>
        }
      </ul>
    </div>
  } @else {
    <span>{{ 'drivers' | join: ['not_data', 'object_card'] | translate }}</span>
  }
</ng-template>

<ng-template #trailers let-data="data">
  @let trailers = getTrailersType(data);

  <hr />

  @if (trailers.length) {
    <div class="object-card__trailers">
      <ul class="disc">
        @for (trailer of trailers; track trailer.id) {
          <li>
            <span class="fw500">{{ trailer.name }}</span>
          </li>
        }
      </ul>
    </div>
  } @else {
    <span>{{ 'trailers' | join: ['not_data', 'object_card'] | translate }}</span>
  }
</ng-template>

<ng-template #customFields let-data="data">
  @let customFields = getCustomFieldType(data);

  <hr />

  @if (customFields?.length) {
    <div class="object-card__custom-fields">
      <ul class="disc">
        @for (field of customFields; track $index) {
          <li>
            <span class="fw500">{{ field.name }}: </span> <span>{{ field.value }}</span>
          </li>
        }
      </ul>
    </div>
  } @else {
    <span>{{ 'customFields' | join: ['not_data', 'object_card'] | translate }}</span>
  }
</ng-template>

<ng-template #sensors let-data="data">
  @let sensors = getSensorsType(data);

  <hr />

  @if (sensors?.length) {
    <div class="object-card__sensors">
      @for (sensor of sensors | sortBy: 'sortIndex'; track $index) {
        <span class="column">
          <span class="fw500">{{ sensor.name }}: </span>
          <span>{{ sensor.value ?? 'No data' | translate }}</span>
        </span>
      }
    </div>
  } @else {
    <span>{{ 'sensors' | join: ['not_data', 'object_card'] | translate }}</span>
  }
</ng-template>

<ng-template #params let-data="data">
  @let params = getParamsType(data);

  <hr />

  @if (params?.length) {
    <div class="object-card__params">
      @for (param of params; track $index) {
        <span class="column">
          <span class="fw500">{{ param.name }}: </span>
          <span>{{ param.value }}</span>
        </span>
      }
    </div>
  } @else {
    <span>{{ 'params' | join: ['not_data', 'object_card'] | translate }}</span>
  }
</ng-template>

<ng-template #specifications let-data="data">
  @let specifications = getSpecificationsType(data);

  <hr />

  @if (specifications?.length) {
    <div class="object-card__specifications">
      @for (specification of specifications; track $index) {
        <span class="column">
          <span class="fw500"
            >{{ specification.name | join: ['availableSpecifications'] | translate }}:
          </span>
          <span>{{ specification.value }}</span>
        </span>
      }
    </div>
  } @else {
    <span>{{ 'specifications' | join: ['not_data', 'object_card'] | translate }}</span>
  }
</ng-template>

<ng-template #geozones let-data="data">
  @let geozones = getGeozoneType(data);

  <hr />

  @if (geozones?.length) {
    <ul class="disc">
      @for (geozone of geozones; track geozone.id) {
        <li>
          <a [class.non-styles]="!isClickableGeozone" (click)="onClickGeozoneName(geozone.id)">{{
            geozone.name
          }}</a>
        </li>
      }
    </ul>
  } @else {
    <span>{{ 'geozones' | join: ['not_data', 'object_card'] | translate }}</span>
  }
</ng-template>

<ng-template #maintenance let-data="data">
  @let maintenance = getMaintenanceType(data);

  <hr />

  @if (maintenance?.list?.length) {
    <div class="object-card__maintenance">
      <ul class="disc">
        @for (interval of maintenance.list; track $index) {
          <li>
            <span class="fw500">{{ interval.name }}: </span>
            @if (interval | maintenanceState; as states) {
              @for (state of states; track $index) {
                <div class="maintenance-state-item" [style.color]="state.color">
                  {{ state.text }}
                </div>
              }
            }
          </li>
        }
      </ul>
    </div>
  } @else {
    <span>{{ 'maintenance' | join: ['not_data', 'object_card'] | translate }}</span>
  }
</ng-template>
